import { CSSObject, ButtonProps } from '@chakra-ui/react';
import { TTableText } from '../../../types';

export const TableItem: CSSObject = {
  borderBottom: '1px solid',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
  borderBottomColor: 'blackAlpha.400',
  borderRight: 'none',
  color: 'white',
  pl: 0,
  py: 2,
};
export const TableHeadingText: CSSObject = {
  color: 'white',
};
export const TransactionWrapper: CSSObject = {
  h: 'auto',
};
export const TableText = ({ textVariation }: TTableText): CSSObject => ({
  color: textVariation === 'positive' ? 'alpha.400' : 'white',
});
export const NoTransactionsText: CSSObject = {
  color: 'white',
};
export const buttonMoreTableProps: ButtonProps = {
  fontWeight: 'normal',
};
export const BoxTransactionsContainer: CSSObject = {
  ml: '1',
};
